import { createContext, useContext } from "react";
import type { SyncEngine } from "./engine";

export const SyncContext = createContext<SyncEngine | null>(null);

export function useSyncEngine(): SyncEngine {
	const engine = useContext(SyncContext);
	if (!engine) throw new Error("useSyncEngine must be used inside <SyncProvider>");
	return engine;
}
